import React, { Component } from 'react'
import history from '../../../history'
import logo from '../../../resources/images/logo.svg'

export default class extends Component {
  handleClick = () => {
    const { isAuthenticated } = this.props
    if (isAuthenticated && history.location.pathname === '/admin/content') {
      return
    }
    history.push('/admin/content')
  }

  render () {
    const { width } = this.props

    return (
      <div onClick={this.handleClick} className='logo' style={{ width: `${width}px` }}>
        <img src={logo} className='logo__source' alt='' />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Layout/Logo/Logo.jsx